export function extractYoutubeId(url: string): string {
    const ytRe = /(youtu.be\/|watch\?v=)([^#&?]+)/;
    const matches = url.match(ytRe);
    const id = matches?.[2];
    return id;
}
